'use strict';

import isUndefined from 'lodash/isUndefined';
import each from 'lodash/each';

var gmaps = require('google').maps,
    SearchUtils = require('search-utils').default,
    SHModal = require('sh-modal'),
    didYouMeanModalTemplate = require('did-you-mean-modal-template');

window.bypassGeocoder = false;
var geocoder_results;

exports.shSearchByAddress = {
    initialize: function(searchStringSel, addressSelectedCallback) {
        this.searchStringSel = searchStringSel;
        this.addressSelectedCallback = addressSelectedCallback;
    },

    lookupAddress: function(callbackFlag) {
        var self = this,
            geocoder;

        geocoder_results = [];

        exports.noCallback = callbackFlag;

        if ($(this.searchStringSel).val() === '') {
            this.addressSelectedCallback(window.shDefaultCityInfo);
            return;
        }

        /* If the geofence isn't established, set it now.*/
        if (isUndefined(window.sw_lat) || isUndefined(window.sw_lng) || isUndefined(window.ne_lat) || isUndefined(window.ne_lng)) {
            // Southwest square geofence bounds.
            window.sw_lat = 41.69957665997156;
            window.sw_lng = -87.9620361328125;
            // Northeast square geofence bounds.
            window.ne_lat = 41.98807738309159;
            window.ne_lng = -87.48138427734375;
        }
        var sw_bounds = new gmaps.LatLng(window.sw_lat, window.sw_lng);
        var ne_bounds = new gmaps.LatLng(window.ne_lat, window.ne_lng);

        geocoder = new gmaps.Geocoder();
        var bounds = new gmaps.LatLngBounds(sw_bounds, ne_bounds);

        geocoder.geocode({
            address: $(this.searchStringSel).val(),
            bounds: bounds
        }, function(results, status) {
            self.handleGeocoderResponse(results, status);
        });
    },

    handleGeocoderResponse: function(results, status, noCallback) {
        var self = this,
            data = {};

        if (status !== gmaps.GeocoderStatus.OK) {
            results = [];
        }

        if (results.length === 1) {
            this.addressSelected(results[0]);
            return;
        }

        for (var i = 0; i < results.length; i++) {
            geocoder_results[i] = results[i];
        }

        data.results = results;
        data.each = each;

        var $modal = $(didYouMeanModalTemplate(data));
        $('body').append($modal);
        SHModal.open($modal[0]);

        // attach suggestion select event
        $modal.on('click', '.list-row button', function() {
            self.addressSelected(geocoder_results[$(this).data('index')]);
            SHModal.close($modal[0]);
        });
    },

    addressSelected: function(geocode_result) {
        if (isUndefined(geocode_result)) {
            $('#latitude').val('');
            $('#longitude').val('');
            return;
        }

        if (!isUndefined(this.addressSelectedCallback)) {
            this.addressSelectedCallback(SearchUtils.getAddressData(geocode_result));
        }
    }
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/modules/common/search/search-by-address.js